const global = window

// Gestion de la mémorisation dans le localStorage
inputs.behavior.memory = function (data, name, niceName, type, input, parent, inputWindow) {
    let memory = data.memory || input.data('memory');
    if (!memory) return data;

    let storageKey = '';
    if (typeof memory === 'string') {
        storageKey = memory.startsWith('field_') ? memory : 'field_' + memory;
    } else if (memory === true || memory === 1 || memory === '1') {
        let formName = (data.form && data.form.name) ? data.form.name + '_' : '';
        let fieldName = data.name || data.id || niceName || name || input.attr('name') || input.attr('id') || 'field';
        let autoKey = formName + fieldName;
        storageKey = autoKey.startsWith('field_') ? autoKey : 'field_' + autoKey;
    }

    if (!storageKey) return data;

    input.data('memory-key', storageKey);

    function restoreValue() {
        let savedValue = null;
        try {
            savedValue = localStorage.getItem(storageKey);
        } catch (e) {
            console.error('Erreur localStorage getItem:', e);
            return;
        }

        console.log('[DEBUG MEMORY] restoreValue:', { storageKey: storageKey, savedValue: savedValue, isTabs: input.hasClass('tabs') });

        if (savedValue === null || savedValue === undefined || savedValue === '') {
            return;
        }

        let parsedValue = savedValue;
        try {
            if (typeof savedValue === 'string' && (savedValue.startsWith('[') || savedValue.startsWith('{'))) {
                parsedValue = JSON.parse(savedValue);
            }
        } catch (e) {}

        input.data('noQ', true);
        global.noQ = true;

        if (input.is(':checkbox')) {
            if (!input.is(':checked')) {
                let shouldCheck = (parsedValue === '1' || parsedValue === 'true' || parsedValue === true || parsedValue === input.val());
                if (shouldCheck) {
                    input.prop('checked', true).trigger('change');
                }
            }
        } else if (input.is(':radio')) {
            let radioGroup = $('input[type="radio"][name="' + input.attr('name') + '"]');
            if (!radioGroup.is(':checked')) {
                let targetRadio = radioGroup.filter('[value="' + parsedValue + '"]');
                if (targetRadio.length) {
                    targetRadio.prop('checked', true).trigger('change');
                }
            }
        } else if (input.is('table') || input.hasClass('table--select') || input.hasClass('selectTable')) {
            let selectedRow = input.find('tbody > tr.selected');
            if (!selectedRow.length && parsedValue) {
                let targetRow = input.find('tbody > tr[data-value="' + parsedValue + '"], tbody > tr[data-id="' + parsedValue + '"]');
                if (targetRow.length) {
                    targetRow.click();
                }
            }
        } else if (input.hasClass('tabs')) {
            if (parsedValue !== null && parsedValue !== undefined && parsedValue !== '') {
                if (inputs.fn && inputs.fn.tabs && inputs.fn.tabs.set) {
                    console.log('[DEBUG MEMORY] calling inputs.fn.tabs.set:', parsedValue);
                    inputs.fn.tabs.set(input, parsedValue);
                }
            }
        } else {
            let currentVal = input.val();
            let isEmpty = (currentVal === '' || currentVal === null || currentVal === undefined);
            if (isEmpty) {
                input.val(parsedValue);
                input.trigger('change');
                if (input.hasClass('select2-hidden-accessible') || input.data('select2')) {
                    input.trigger('change.select2');
                }
            }
        }

        input.removeData('noQ');
        global.noQ = false;
    }

    let lastSavedVal = undefined;
    function saveValue() {
        if (input.data('noQ') || global.noQ) return;

        let valToSave;
        if (input.is(':checkbox')) {
            valToSave = input.is(':checked') ? (input.val() || '1') : '0';
        } else if (input.is(':radio')) {
            valToSave = $('input[type="radio"][name="' + input.attr('name') + '"]:checked').val();
        } else if (input.is('table') || input.hasClass('table--select') || input.hasClass('selectTable')) {
            let selectedRow = input.find('tbody > tr.selected');
            valToSave = selectedRow.attr('data-value') || selectedRow.attr('data-id') || selectedRow.data('value') || selectedRow.data('id');
        } else if (input.hasClass('tabs')) {
            valToSave = input.val() || input.attr('value');
            if (valToSave === undefined || valToSave === null || valToSave === '') {
                const currentTab = input.find(' > ul .ui-tabs-active, > .tabs__nav__wrap > ul .ui-tabs-active');
                const activePane = $('#' + currentTab.attr('aria-controls'));
                valToSave = activePane.attr('data-value') || activePane.attr('value') || currentTab.attr('data-value') || currentTab.index();
            }
        } else {
            valToSave = input.val();
        }

        if (valToSave === lastSavedVal) return;
        lastSavedVal = valToSave;

        console.log('[DEBUG MEMORY] saveValue:', { storageKey: storageKey, valToSave: valToSave });

        try {
            if (valToSave !== null && valToSave !== undefined && valToSave !== '') {
                localStorage.setItem(storageKey, typeof valToSave === 'object' ? JSON.stringify(valToSave) : valToSave);
            } else {
                localStorage.removeItem(storageKey);
            }
        } catch (e) {
            console.error('Erreur localStorage setItem:', e);
        }
    }

    // Restaurer à l'affichage si le champ n'a aucune valeur
    restoreValue();

    // Mémoriser lors des changements
    input.on('change', function () {
        saveValue();
    });

    // Écouter les rechargements / ajax options
    input.on('options:loaded reloaded ajax:done', function () {
        let cur = input.val();
        if (cur === '' || cur === null || cur === undefined) {
            restoreValue();
        }
    });

    return data;
};
